<template>
  <div class="external-component4">
  </div>
</template>

<script>
const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-scale'), require('d3-array'), require('d3-axis'), require('d3-time-format'), require('d3-shape'), require('d3-format'))

var mobile = false;
(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) mobile = true })(navigator.userAgent || navigator.vendor || window.opera)

export default {
  props: ['attributes'],
  methods: {
    initCode (value) {
      d3.json('https://s3-st-graphics-json.s3-ap-southeast-1.amazonaws.com/2019-ncov/timeseries.json', rawData => {
        const parseTime = d3.timeParse('%Y-%m-%d')

        let hubei = rawData.filter(d => d.province === 'Hubei')
        const others = rawData.filter(d => d.province !== 'Hubei' && 'province' in d)

        hubei = hubei.map(d => ({date: parseTime(d.date), cases: +d.cases, area: 'Hubei'}))

        let othersSummarized = d3.rollups(others, v => d3.sum(v, d => d.cases), d => d.date)

        othersSummarized = othersSummarized.map(d => ({date: parseTime(d[0]), cases: +d[1], area: 'Others'}))

        var margin = {top: 30, right: mobile ? 10 : 70, bottom: 30, left: mobile ? 5 : 50}
        var clientWidth = this.$el.clientWidth
        var width = clientWidth - margin.left - margin.right // Use the window's width
        var height = mobile ? clientWidth - margin.top - margin.bottom : clientWidth * 0.8 - margin.top - margin.bottom // Use the window's height

        var circleSize = 4

        var linechart = d3.select(this.$el)
                .append('div')
                .attr('id', 'linechartWrapper')
        // The number of datapoints
        const yMax = hubei[0].cases
        var xScale

        // 5. X scale will use the index of our data
        if (mobile) {
          xScale = d3.scaleTime()
                .domain([parseTime('2020-01-20'), d3.max(hubei, d => d.date)]) // input
                .range([0, width]) // output
        } else {
          xScale = d3.scaleTime()
                .domain(d3.extent(hubei, d => d.date)) // input
                .range([0, width]) // output
        }

        // 6. Y scale will use the randomly generate number
        var yScale = d3.scaleLinear()
                .domain([0, yMax]) // input
                .range([height, 0])

        var xAxis = d3.axisBottom(xScale).ticks(mobile ? 2 : 5).tickFormat(d3.timeFormat('%-m/%-d'))
        var yAxis = d3.axisRight(yScale)
                    .tickSize(width)
                    .tickFormat(d3.format(',.0f'))

        // 7. d3's line generator
        var line = d3.line()
                .x(function (d) { return xScale(d.date) }) // set the x values for the line generator
                .y(function (d) { return yScale(d.cases) }) // set the y values for the line generator

        // 8. An array of objects of length N. Each object has key -> value pair, the key being "y" and the value is a random number

        // 1. Add the SVG to the page and employ #2
        var svg = linechart
                .append('div')
                .attr('class', 'flexWrapper')
                .append('svg')
                .attr('width', width + margin.left + margin.right)
                .attr('height', height + margin.top + margin.bottom)

        var chart = svg.append('g')
                .attr('id', 'linechart')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

        // 3. Call the x axis in a group tag
        chart.append('g')
                .attr('class', 'xAxis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis)

        // 4. Call the y axis in a group tag
        chart.append('g')
                .attr('class', 'yAxis')
                .call(yAxis)
                .call(g => g.select('.domain')
                    .remove())
                .call(g => g.selectAll('.tick:not(:first-of-type) line')
                    .attr('stroke-opacity', 0.5)
                    .attr('stroke-dasharray', '1,1'))
                .call(g => g.selectAll('.tick text')
                    .attr('x', -2)
                    .attr('dy', mobile ? -4 : 5)
                    .style('text-anchor', mobile ? 'start' : 'end'))

        // 9. Append the path, bind the data, and call the line generator
        chart.append('path')
                .datum(hubei) // 10. Binds data to the line
                .attr('class', 'line') // Assign a class for styling
                .attr('d', line) // 11. Calls the line generator

        chart.append('path')
                .datum(othersSummarized) // 10. Binds data to the line
                .attr('class', 'lineOthers') // Assign a class for styling
                .attr('d', line) // 11. Calls the line generator

        chart.append('circle')
                .datum(hubei[0]) // 10. Binds data to the line
                .attr('class', 'lastCircle') // Assign a class for styling
                .attr('cx', d => xScale(d.date)) // 11. Calls the line generator
                .attr('cy', d => yScale(d.cases))
                .attr('r', circleSize) // 11. Calls the line generator

        chart.append('circle')
                .datum(othersSummarized[0]) // 10. Binds data to the line
                .attr('class', 'lastCircleOthers') // Assign a class for styling
                .attr('cx', d => xScale(d.date)) // 11. Calls the line generator
                .attr('cy', d => yScale(d.cases))
                .attr('r', circleSize) // 11. Calls the line generator

        chart.append('text')
                .datum(hubei[0]) // 10. Binds data to the line
                .attr('class', 'chartLable') // Assign a class for styling
                .attr('x', d => mobile ? 0 : xScale(d.date) + 6) // 11. Calls the line generator
                .attr('y', d => mobile ? yScale(d.cases) - 10 : yScale(d.cases) + 5)
                .style('fill', mobile ? '#d4883d' : 'black')
                .text('Hubei')

        chart.append('text')
                .datum(othersSummarized[0]) // 10. Binds data to the line
                .attr('class', 'chartLableOthers') // Assign a class for styling
                .attr('x', d => mobile ? 50 : xScale(d.date) + 6) // 11. Calls the line generator
                .attr('y', d => mobile ? yScale(yMax) - 10 : yScale(d.cases))
                .style('fill', mobile ? '#d4883d40' : 'black')
                .html('All other')

        chart.append('text')
                .datum(othersSummarized[0]) // 10. Binds data to the line
                .attr('class', 'chartLableOthers') // Assign a class for styling
                .attr('x', d => mobile ? 110 : xScale(d.date) + 6) // 11. Calls the line generator
                .attr('y', d => mobile ? yScale(yMax) - 10 : yScale(d.cases) + 16)
                .style('fill', mobile ? '#d4883d40' : 'black')
                .html('provinces')

        if (!mobile) {
                chart.append('line')
                        .attr('x1', xScale(parseTime('2020-01-23'))) // <<== change your code here
                        .attr('y1', 0)
                        .attr('x2', xScale(parseTime('2020-01-23'))) // <<== and here
                        .attr('y2', height)
                        .style('stroke-width', 1)
                        .style('stroke', 'lightgrey')
                        .style('fill', 'none')

                chart.append('text')
                        .attr('class', 'startingLineText') // Assign a class for styling
                        .attr('x', xScale(parseTime('2020-01-23')) + 2) // 11. Calls the line generator
                        .attr('y', yScale(yMax / 2))
                        .text('Jan 23')

                chart.append('text')
                        .attr('class', 'startingLineText') // Assign a class for styling
                        .attr('x', xScale(parseTime('2020-01-23')) + 2) // 11. Calls the line generator
                        .attr('y', yScale(yMax / 2) + 18)
                        .text('Wuhan travel')

                chart.append('text')
                        .attr('class', 'startingLineText') // Assign a class for styling
                        .attr('x', xScale(parseTime('2020-01-23')) + 2) // 11. Calls the line generator
                        .attr('y', yScale(yMax / 2) + 36)
                        .text('ban enforced')
        }
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.initCode()
    }, 200)
  }
}
</script>
<style lang="scss">
.line {
  fill: none;
  stroke: #D4883D;
  stroke-width: 2px;
}

.lineOthers {
  fill: none;
  stroke: #d4883d40;
  stroke-width: 2px;
}

.tick text {
    font-family: $font-CuratorRegular;
    font-size: 15px;
    @include breakpoint($d_medium) {
      font-size: 15px;
    }
}

#linechartWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.chartLable {
    font-family: $font-CuratorBold;
    font-size: 15px;
}

.chartLableOthers {
    font-family: $font-CuratorRegular;
    font-size: 15px;
}

.lastCircle {
    fill: #D4883D;
}

.lastCircleOthers {
    fill: #d4883d40;
}

.startingLineText {
    font-family: $font-CuratorRegular;
    font-size: 15px;
}
</style>
